import Vue from 'vue'
import Toast from '@/components/toast.vue'

// 单例：避免多次提示产生重叠节点
let instance = null
let timer = null

/**
 * 全局轻提示
 * @param {string} message 文案
 * @param {number} duration 自动消失时长(ms)，传 0 表示不自动消失
 */
function showToast (message, duration = 1500) {
  if (!instance) {
    const Ctor = Vue.extend(Toast)
    instance = new Ctor()
    instance.$mount()
    document.body.appendChild(instance.$el)
  }
  instance.message = message
  instance.visible = true
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  if (duration > 0) {
    timer = setTimeout(() => {
      instance.visible = false
    }, duration)
  }
}

export default {
  install (V) {
    V.prototype.$toast = showToast
  }
}



// WEBPACK FOOTER //
// ./src/utils/toast.js